import { Component, ElementRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TransactionAuthorizationComponent, UserMessagesComponent } from '@zero/shared/ui-web-components';
import { DividerComponent, ModalComponent, NotificationComponent } from '@zero/shared/ui-web-design-system';
import { CustomerStateFacade } from '@zero/shared/util-global-state';
import { AuthorizationData, AuthPayloadTicket, Ticket, TicketData, TransactionAuthorizationResult } from '@zero/shared/util-models';
import { UserMessagesHolderService } from '@zero/shared/util-web-app-services';
import { TicketFacade } from '@zero/tickets/domain';
import { DialogMode } from '@zero/trade/feature-trade/base';

@Component({
  selector: 'self-service-activate-ftg',
  templateUrl: './activate-ftg-modal.component.html',
  imports: [
    ModalComponent,
    TranslocoPipe,
    NotificationComponent,
    DividerComponent,
    TransactionAuthorizationComponent,
    UserMessagesComponent,
  ],
})
export class ActivateFtgModalComponent implements OnInit {
  @Input() public showExperienceNotice = false;
  @Input() public dialogMode: DialogMode | undefined = undefined;

  public readonly modal = inject(NgbActiveModal);
  @ViewChild('tanInput') public tanInput: ElementRef;
  public dataToAuthorize: AuthorizationData<AuthPayloadTicket>;

  readonly #customerStateFacade = inject(CustomerStateFacade);
  readonly #ticketFacade = inject(TicketFacade);
  readonly #messageService = inject(UserMessagesHolderService);

  public ngOnInit(): void {
    this.#messageService.clearAllMessages();
    this.dataToAuthorize = this.#createTicket();
  }

  public authorizedTransactionResult(result: TransactionAuthorizationResult): void {
    if (result.success) {
      this.#messageService.clearAllMessages();
      this.#messageService.addInfoMessage(
        'Die Autorisierung war erfolgreich. Deine Freischaltung für den Handel von Hebelprodukten ist aktiviert.',
        true,
      );
      this.dataToAuthorize = undefined;
      this.#ticketFacade.loadTickets(true);
      this.#customerStateFacade.loadCustomerBaseData(true);
      this.modal.close('ftgNotice');
    } else if (result.reason === 'CanceledByUser') {
      this.dataToAuthorize = undefined;
    }
  }

  readonly #createTicket = (): AuthorizationData<AuthPayloadTicket> => {
    const ticket = new Ticket();
    ticket.customerId = this.#customerStateFacade.customerBaseData.customerId;
    ticket.type = 'FTG_VIATAN';
    ticket.ticketData = new TicketData();
    ticket.ticketData.additionalProperties = {};
    return new AuthorizationData<AuthPayloadTicket>(new AuthPayloadTicket(ticket));
  };
}
